import React from 'react';
import ReactHtml from 'components/shared/ReactHtml';
import { IGongProps } from './types';

export const Gong = ({ data }) => {
  if (!data || !data.embeddable) return null;

  return (
    <>
      <div className="media">
        <iframe
          width="770"
          height="815"
          src={`https://app.gong.io/embedded-call?call-id=${data.callId}&from=${
            data.startTimestamp ?? ''
          }&to=${data.endTimestamp ?? ''}`}
          frameBorder="0"
          title={`gong-call-iframe-${data.callId}`}
        />

        {data.caption && (
          <figcaption>
            <ReactHtml>{data.caption}</ReactHtml>
          </figcaption>
        )}
      </div>
    </>
  );
};

Gong.propTypes = IGongProps;

export default Gong;
